var map = {
	"./Rented_out.svg": "804b",
	"./area.svg": "22c9",
	"./average_price.svg": "f60d",
	"./lettable_area.svg": "8c0f",
	"./letting_rate.svg": "0eb3",
	"./not_rented.svg": "3fce",
	"./rent.svg": "f12b",
	"./rental_rate.svg": "de79",
	"./top.svg": "deee",
	"./vacancy_rate.svg": "7da6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";